import { render, staticRenderFns } from "./AppHistory.vue?vue&type=template&id=42dbfa70&scoped=true"
import script from "./AppHistory.vue?vue&type=script&lang=ts"
export * from "./AppHistory.vue?vue&type=script&lang=ts"
import style0 from "./AppHistory.vue?vue&type=style&index=0&id=42dbfa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dbfa70",
  null
  
)

export default component.exports